const sectionCode = "SPRO2";
const chartCode = "C040x";

import { Procedures } from "modules/provider/shared/procedure-charts";

function T40Procedures() {
  return <Procedures chartCode={chartCode} sectionCode={sectionCode} />;
}

export { T40Procedures };
